<template>
<div>
  <v-content>
    <section>
      <v-parallax :src="require('@/app/assets/images/nature28.jpg')" height="500">
        <v-layout row class="mt-4">
          <div :class="ui.textDisplay1Light"> {{this.companyTitle2}} legal </div>
          <v-spacer/>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" href="https://www.besea.com.au">
              <v-icon dark left>public</v-icon>
              besea
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" href="https://www.besea.com.au">
              <v-icon dark>public</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/about'">
              <v-icon dark left>info_outline</v-icon>
              about
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small color="white" :to="'/about'">
              <v-icon dark>info_outline</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseShowXs">
            <v-btn flat icon small :color="ui.btnColorLight" :to="'/'">
              <v-icon dark>home</v-icon>
            </v-btn>
          </div>
          <div :class="ui.responseHideXs">
            <v-btn small :color="ui.btnColorLight" :to="'/'">
              <v-icon dark left>home</v-icon>
              home
            </v-btn>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-layout column class="my-5" align-center>
         <v-flex xs12 sm4 class="my-3">
           <div class="text-xs-center">
             <div :class="ui.textHeadline">
               Data Privacy
             </div>
           </div>
         </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm4 md4 lg2 offset-xs0 offset-md0 offset-lg3>
          <InfoCard :info="InfoCard1"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2 >
          <InfoCard :info="InfoCard2"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2>
          <InfoCard :info="InfoCard3"/>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-layout column class="my-5" align-center>
         <v-flex xs12 sm4 class="my-3">
           <div class="text-xs-center">
             <div :class="ui.textHeadline">
               Terms of Use
             </div>
           </div>
         </v-flex>
      </v-layout>
      <v-layout row wrap align-center class="mt-4 ml-4 mr-4">
        <v-flex xs12 sm4 md4 lg2 offset-xs0 offset-md0 offset-lg3>
          <InfoCard :info="InfoCard4"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2 >
          <InfoCard :info="InfoCard5"/>
        </v-flex>
        <v-flex xs12 sm4 md4 lg2>
          <InfoCard :info="InfoCard6"/>
        </v-flex>
      </v-layout>
    </section>


    <section>
      <v-parallax :src="require('@/app/assets/images/nature37.jpg')" height="500">
        <v-layout column fill-height>
          <div :class="ui.textDisplay1Light"> review </div>
          <v-layout align-center justify-start wrap row fill-height>
            <LegalCardPublic :data="{
              type: 'DP',
              btnColor: this.ui.btnColorLight,
              btnType: 'flat',
              enableAgreeBtn: false
              }"/>
            <LegalCardPublic :data="{
              type: 'TC',
              btnColor: this.ui.btnColorLight,
              btnType: 'flat',
              enableAgreeBtn: false
              }"/>
          </v-layout>
        </v-layout>
      </v-parallax>
      <v-layout row>
        <v-spacer/>
        <div :class="ui.textImage"> Nature Drone Phontogrpahy </div>
      </v-layout>
    </section>

    <v-container grid-list-xl>
      <v-layout row wrap justify-center class="my-5">
        <v-flex xs12 sm4>
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div :class="ui.textHeadline">access</div>
            </v-card-title>
            <v-card-text :class="ui.textDescription">
              All images are the property of Woodside Energy Group Ltd. and Rio Tinto Ltd. Please read image and public material terms and conditions to review limitations and privileges to use these images in the respective companies websites.
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card class="elevation-0 transparent">
            <v-card-title primary-title class="layout justify-center">
              <div :class="ui.textHeadline">
                {{this.companyTitle2}}
              </div>
            </v-card-title>
            <v-card-text :class="ui.textDescription">
              besea is web based application using real time data to store facility and asset information.  Centralised repository of data for all asset test and inspection results allows fast analysis of equipment condition. Instant access to data can enable quality decisions to improve asset safety, reliability and lower operating cost.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <PublicFooterPage/>
  </v-content>
</div>
</template>


<script>
/* eslint-disable */
import InfoCard from "../components/InfoCard"
import PublicFooterPage from "../components/PublicFooterPage"
import apptheme from "@/frame/theme/mixins/apptheme.js";
import LegalCardPublic from "@/admin/general/components/LegalCardPublic";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";

export default {
  components: {
    InfoCard,
    PublicFooterPage,
    LegalCardPublic
  },
  mixins: [apptheme, publicGlobals],
  data() {
    return {
      currentPagePath: "/legal",
      InfoCard1: {
        title: "Collection",
        icon: "playlist_add",
        text: "User and business intelligence data is collected to enable system operation. All company data generated by the user belongs to the company. Data change is recorded and can be viewed in activity log."
      },
      InfoCard2: {
        title: "Storage",
        icon: "cloud",
        text: "All personal or company data generated by the user or system is stored in a secure cloud database infrastructure provided by a reputable service provider. Personal data is protected from unauthorised access."
      },
      InfoCard3: {
        title: "Access",
        icon: "key",
        text: "All user information is available through the standard authentication process. Business intelligence data for the company and facility is available depending on user access authority level."
      },
      InfoCard4: {
        title: "Services",
        icon: "apps",
        text: "All user and besea services shall comply with the latest revision of Terms of Use. Any update to the Policy requires user to review any changes to the document and reagree to new conditions."
      },
      InfoCard5: {
        title: "Responsibility",
        icon: "person",
        text: "The user is responsible for providing accurate and up to date information to ensure credibility and integrity of the system. These include user skills, capabilities or company legal information."
      },
      InfoCard6: {
        title: "Maintenance",
        icon: "build",
        text: "The platform is available 24/7 from any device and location assuming the internet connection is reliable. In rare cases critical offline platform maintenance may impact system availability and reliability."
      }
    };
  }
};
</script>
